module.exports = __webpack_public_path__ + "img/blue-bmw.1b2e82a2.png";